<template>
  <div
    class="width98 margin-auto backwhite pad-bot30"
    style="min-height: 700px"
  >
    <!-- 头部 -->
    <div class="toolbtn flex">
      <el-tooltip class="item" effect="dark" content="刷新" placement="top">
        <div @click="refresh()" class="cursorpointer margin-top10">
          <img
            src="@/assets/barsvg/icon／12sx(1).png"
            style="position: relative; top: 2px"
            alt=""
          />
          <span class="f12 pad-left5" style="color: #969eac">刷新</span>
        </div>
      </el-tooltip>
      <el-tooltip class="item" effect="dark" content="返回" placement="top">
        <callback></callback>
      </el-tooltip>
    </div>

    <!-- 等待 -->
    <div class="waitfor" v-if="cesi">
      <div class="feature">
        <div class="feature-box">
          <div class="pulse">
            <div
              class="loading"
              :class="
                titlenamelength == 1
                  ? 'loadingone'
                  : titlenamelength == 2
                  ? 'loadingtwo'
                  : titlenamelength == 3
                  ? 'loadingthree'
                  : titlenamelength == 4
                  ? 'loadingfor'
                  : titlenamelength == 5
                  ? 'loadingfive'
                  : 'loadingsix'
              "
            >
              {{ titlename }}
            </div>
          </div>
          <div class="pulse1"></div>
          <div class="pulse2"></div>
        </div>
      </div>
    </div>
    <div class="waitTitle" v-if="cesi">
      <p id="wrapper">正在检测商标字符</p>
      <p id="wrapper2">正在检测商标合法性</p>
      <p id="wrapper3">正在检测检索相同商标</p>
      <p id="wrapper4">正在检索相似商标</p>
    </div>

    <!-- 结果 -->
    <div class="resultBox" v-if="jieguo">
      <p class="resiltTitle">商标注册通过率测试结果报告</p>
      <p class="resiltdetil">本报告仅供参考,如需精准结果请咨询管家</p>
    </div>
    <div class="trademarkBox" v-if="jieguo">
      <p class="trademarkcont">{{ trademark }}</p>
    </div>
    <div class="setting-cont" v-if="jieguo">
      <el-collapse v-model="activeNames" class="select" accordion>
        <el-collapse-item
          class="select-null"
          v-for="(item, index) in jgpage.result"
          :key="index"
          :name="index"
        >
          <template slot="title" appear>
            <div class="width94 margin-auto flex-betweencen">
              <p class="width45 textalign-left">
                {{ "第" + index + "类" }}
              </p>
              <p class="width30">
                <span class="pad-left35">通过率 : {{ item.rate }}%</span>
              </p>
              <p class="width25 textalign-right bluecolor">查看明细</p>
            </div>
          </template>
          <el-tabs v-model="activeName" class="changeactive">
            <el-tab-pane label="相同商标" name="first">
              <div
                class="select-cont cursorpointer"
                v-for="(_item, _index) in item.equal"
                :key="_index"
                @click="todetail(_index)"
              >
                <p class="select-item">
                  <span class="itemName">{{ _item.TrademarkName }}</span>
                  <span class="itemName">{{ _item.InternationalClass }}类</span>
                </p>
                <div class="select-item">
                  <p class="width45 textalign-left">
                    {{ _item.RegisterName }}
                  </p>
                  <p class="width30">
                    <span class="pad-left50"> {{ _item.RegAnnNumber }}</span>
                  </p>
                  <p class="width25 textalign-right">{{ _item.ApplyDate }}</p>
                </div>
              </div>
              <div
                class="width100 margin-auto"
                style="background: #f5fcfc"
                v-if="item.equal == null"
              >
                <p class="textalign-center f16 pad-top20 pad-bot20 corlor64">
                  抱歉，没有找到相同商标
                </p>
              </div>
            </el-tab-pane>
            <el-tab-pane label="相似商标" name="second">
              <div
                class="select-cont cursorpointer"
                v-for="(items, indexs) in item.similar"
                :key="indexs"
                @click="todetails(indexs)"
              >
                <p class="select-item">
                  <span class="itemName">{{ items.TrademarkName }}</span>
                  <span class="itemName">{{ items.InternationalClass }}类</span>
                </p>
                <div class="select-item">
                  <p class="width45 textalign-left">
                    {{ items.RegisterName }}
                  </p>
                  <p class="width30">
                    <span class="pad-left50"> {{ items.RegAnnNumber }}</span>
                  </p>
                  <p class="width25 textalign-right">{{ items.ApplyDate }}</p>
                </div>
              </div>
              <div
                class="width100 margin-auto"
                style="background: #f5fcfc"
                v-if="item.similar == null"
              >
                <p class="textalign-center f16 pad-top20 pad-bot20 corlor64">
                  抱歉，没有找到相似商标
                </p>
              </div>
            </el-tab-pane>
          </el-tabs>
        </el-collapse-item>
      </el-collapse>
    </div>

    <el-dialog
      title=""
      :visible.sync="dialogVisiblenull"
      :close-on-click-modal="false"
      :show-close="true"
      :center="true"
      :modal="true"
      :modal-append-to-body="true"
      :append-to-body="true"
      width="25%"
      class="errorbox"
    >
      <p class="textalign-left f16">提示</p>
      <div class="textalign-left margin-top10">
        <span class="errormessage">{{ errormessage }}</span>
      </div>
      <span slot="footer" class="dialog-footer">
        <span @click="dialogVisiblenull = false" class="errorbutton">
          确 定
        </span>
      </span>
    </el-dialog>
    <el-dialog
      title=""
      :visible.sync="dialogVisibledetails"
      :close-on-click-modal="false"
      :show-close="true"
      :center="true"
      :modal="true"
      :modal-append-to-body="true"
      :append-to-body="true"
      width="40%"
      class="errorbox"
    >
      <p class="textalign-left f16">商标详情</p>
      <div class="textalign-left margin-top10">
        <div class="margin-top20 flex">
          <p class="width15">商标名称 :</p>
          <p class="f14">{{ TrademarkNames }}</p>
        </div>
        <div class="margin-top20 flex">
          <p class="width15">分类号 :</p>
          <p class="f14">{{ InternationalClasss }}</p>
        </div>
        <div class="margin-top20 flex">
          <p class="width15">注册人 :</p>
          <p class="f14">{{ RegisterNames }}</p>
        </div>
        <div class="margin-top20 flex">
          <p class="width15">注册日期 :</p>
          <p class="f14">{{ ApplyDates }}</p>
        </div>
        <div class="margin-top20 flex">
          <p class="width15">注册地址 :</p>
          <p class="f14">{{ ApplyAddresss }}</p>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <span @click="dialogVisibledetails = false" class="errorbutton">
          确 定
        </span>
      </span>
    </el-dialog>
    <el-dialog
      title=""
      :visible.sync="dialogVisibledetails"
      :close-on-click-modal="false"
      :show-close="true"
      :center="true"
      :modal="true"
      :modal-append-to-body="true"
      :append-to-body="true"
      width="40%"
      class="errorbox"
    >
      <p class="textalign-left f16">商标详情</p>
      <div class="textalign-left margin-top10">
        <div class="margin-top20 flex">
          <p class="width15">商标名称 :</p>
          <p class="f14">{{ TrademarkName }}</p>
        </div>
        <div class="margin-top20 flex">
          <p class="width15">分 类 号 :</p>
          <p class="f14">{{ InternationalClass }}</p>
        </div>
        <div class="margin-top20 flex">
          <p class="width15">注 册 人 :</p>
          <p class="f14">{{ RegisterName }}</p>
        </div>
        <div class="margin-top20 flex">
          <p class="width15">注册日期 :</p>
          <p class="f14">{{ ApplyDate }}</p>
        </div>
        <div class="margin-top20 flex">
          <p class="width15">注册地址 :</p>
          <p class="f14">{{ ApplyAddress }}</p>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <span @click="dialogVisibledetails = false" class="errorbutton">
          确 定
        </span>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import BUS from "@/BUS/BUS";
import callback from "@/components/callback.vue";
import { trademarktoolsrate } from "@/api/patent/patent.api";
import $ from "jquery";
import "@/assets/css/testwait.css";
export default {
  data() {
    return {
      errormessage: "",
      dialogVisiblenull: false,
      dialogVisibledetail: false,
      dialogVisibledetails: false,
      titlename: "",
      titlenamelength: "",
      activeNames: [0],
      name: "第35类",
      activeName: "first",
      cesi: true,
      jieguo: false,
      jgpage: [],
      trademark: "",

      TrademarkName: "",
      InternationalClass: "",
      RegisterName: "",
      ApplyDate: "",
      ApplyAddress: "",

      TrademarkNames: "",
      InternationalClasss: "",
      RegisterNames: "",
      ApplyDates: "",
      ApplyAddresss: "",
    };
  },
  methods: {
    todetail(index) {
      this.dialogVisibledetail = true;
      for (var key in this.jgpage.result) {
        this.TrademarkNames =
          this.jgpage.result[key].equal[index].TrademarkName;
        this.InternationalClasss =
          this.jgpage.result[key].equal[index].InternationalClass;
        this.RegisterNames = this.jgpage.result[key].equal[index].RegisterName;
        this.ApplyDates = this.jgpage.result[key].equal[index].ApplyDate;
        this.ApplyAddresss = this.jgpage.result[key].equal[index].ApplyAddress;
      }
    },
    todetails(index) {
      this.dialogVisibledetails = true;
      for (var key in this.jgpage.result) {
        this.TrademarkName =
          this.jgpage.result[key].similar[index].TrademarkName;
        this.InternationalClass =
          this.jgpage.result[key].similar[index].InternationalClass;
        this.RegisterName = this.jgpage.result[key].similar[index].RegisterName;
        this.ApplyDate = this.jgpage.result[key].similar[index].ApplyDate;
        this.ApplyAddress = this.jgpage.result[key].similar[index].ApplyAddress;
      }
    },
  },
  components: {
    callback,
  },
  created() {
    if (window.sessionStorage.getItem("truefalse") == 0) {
      this.titlename = window.sessionStorage.getItem("inputciti");
      var pattern = new RegExp("[\u4E00-\u9FA5]+");
      if (pattern.test(this.titlename) == false) {
        if (this.titlename.length == 1) {
          this.titlenamelength = 1;
        } else if (this.titlename.length == 2) {
          this.titlenamelength = 1;
        } else if (this.titlename.length == 3) {
          this.titlenamelength = 1;
        } else if (this.titlename.length == 4) {
          this.titlenamelength = 2;
        } else if (this.titlename.length == 5) {
          this.titlenamelength = 2;
        } else if (this.titlename.length == 6) {
          this.titlenamelength = 2;
        } else if (this.titlename.length == 7) {
          this.titlenamelength = 3;
        } else if (this.titlename.length == 8) {
          this.titlenamelength = 3;
        } else if (this.titlename.length == 9) {
          this.titlenamelength = 3;
        } else if (this.titlename.length == 10) {
          this.titlenamelength = 4;
        } else if (this.titlename.length == 11) {
          this.titlenamelength = 4;
        } else if (this.titlename.length == 12) {
          this.titlenamelength = 4;
        } else if (this.titlename.length == 13) {
          this.titlenamelength = 5;
        } else if (this.titlename.length == 14) {
          this.titlenamelength = 5;
        } else if (this.titlename.length == 15) {
          this.titlenamelength = 5;
        } else {
          this.titlenamelength = 6;
        }
      } else {
        this.titlenamelength = this.titlename.length;
      }
      trademarktoolsrate({
        class: window.sessionStorage.getItem("citiclass").split(","), //指定国际分类
        trademark: window.sessionStorage.getItem("inputciti"),
      }).then((res) => {
        if (res.data.code == 200) {
          this.jgpage = res.data.data;
          this.trademark = res.data.data.trademark;
          setTimeout(() => {
            this.cesi = false;
            this.jieguo = true;
          }, 4000);
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    } else {
      this.titlename = window.sessionStorage.getItem("inputpage");
      var patterns = new RegExp("[\u4E00-\u9FA5]+");
      if (patterns.test(this.titlename) == false) {
        if (this.titlename.length == 1) {
          this.titlenamelength = 1;
        } else if (this.titlename.length == 2) {
          this.titlenamelength = 1;
        } else if (this.titlename.length == 3) {
          this.titlenamelength = 1;
        } else if (this.titlename.length == 4) {
          this.titlenamelength = 2;
        } else if (this.titlename.length == 5) {
          this.titlenamelength = 2;
        } else if (this.titlename.length == 6) {
          this.titlenamelength = 2;
        } else if (this.titlename.length == 7) {
          this.titlenamelength = 3;
        } else if (this.titlename.length == 8) {
          this.titlenamelength = 3;
        } else if (this.titlename.length == 9) {
          this.titlenamelength = 3;
        } else if (this.titlename.length == 10) {
          this.titlenamelength = 4;
        } else if (this.titlename.length == 11) {
          this.titlenamelength = 4;
        } else if (this.titlename.length == 12) {
          this.titlenamelength = 4;
        } else if (this.titlename.length == 13) {
          this.titlenamelength = 5;
        } else if (this.titlename.length == 14) {
          this.titlenamelength = 5;
        } else if (this.titlename.length == 15) {
          this.titlenamelength = 5;
        } else {
          this.titlenamelength = 6;
        }
      } else {
        this.titlenamelength = this.titlename.length;
      }
      trademarktoolsrate({
        industry: window.sessionStorage.getItem("pageclass").split(","), //行业代码
        trademark: window.sessionStorage.getItem("inputpage"),
      }).then((res) => {
        if (res.data.code == 200) {
          this.jgpage = res.data.data;
          this.trademark = res.data.data.trademark;
          setTimeout(() => {
            this.cesi = false;
            this.jieguo = true;
          }, 4000);
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    }

    $(document).ready(function () {
      let loading = $(".loading").wrapInner("<div></div>"),
        min = 20,
        max = 70,
        minMove = 10,
        maxMove = 20;

      startAnimation(loading);

      loading.on(
        "animationend webkitAnimationEnd oAnimationEnd",
        "span:last-child",
        (e) => {
          startAnimation(loading);
        }
      );

      //设置CSS变量并根据需要生成跨距
      function setCSSVars(elem, min, max, minMove, maxMove) {
        let width = Math.ceil(elem.width()),
          text = elem.text();
        for (let i = 1; i < width; i++) {
          let num = Math.floor(Math.random() * (max - min + 1)) + min,
            numMove =
              Math.floor(Math.random() * (maxMove - minMove + 1)) + minMove,
            dir = i % 2 == 0 ? 1 : -1,
            spanCurrent = elem.find("span:eq(" + i + ")"),
            span = spanCurrent.length ? spanCurrent : $("<span />");
          span.css({
            "--x": i - 1 + "px",
            "--move-y": num * dir + "px",
            "--move-y-s":
              (i % 2 == 0 ? num * dir - numMove : num * dir + numMove) + "px",
            "--delay": i * 10 + "ms",
          });
          if (!spanCurrent.length) {
            elem.append(span.text(text));
          }
        }
      }

      //开始动画
      function startAnimation(elem) {
        elem.removeClass("start");
        setCSSVars(elem, min, max, minMove, maxMove);
        void elem[0].offsetWidth;
        elem.addClass("start");
      }
    });
  },
  mounted() {},
  updated() {},
};
</script>

<style scoped>
/* 字体跳动 */
@keyframes fade-in {
  0% {
    opacity: 0;
  } /*初始状态 透明度为0*/
  10% {
    opacity: 0.1;
  }
  20% {
    opacity: 0.2;
  }
  30% {
    opacity: 0.3;
  }
  40% {
    opacity: 0.4;
  }
  50% {
    opacity: 0.5;
  }
  60% {
    opacity: 0.6;
  }

  70% {
    opacity: 0.7;
  }
  80% {
    opacity: 0.8;
  }
  90% {
    opacity: 0.9;
  } /*过渡状态 透明度为0*/
  100% {
    opacity: 1;
  } /*结束状态 透明度为1*/
}

/* 文字显影 */
@-webkit-keyframes fade-in {
  /*针对webkit内核*/
  0% {
    opacity: 0;
  }
  40% {
    opacity: 2;
  }
  100% {
    opacity: 4;
  }
}
#wrapper {
  animation: fade-in; /*动画名称*/
  animation-duration: 2s; /*动画持续时间*/
  -webkit-animation: fade-in 2s; /*针对webkit内核*/
}
#wrapper2 {
  animation: fade-in; /*动画名称*/
  animation-duration: 3s; /*动画持续时间*/
  -webkit-animation: fade-in 3s; /*针对webkit内核*/
}
#wrapper3 {
  animation: fade-in; /*动画名称*/
  animation-duration: 4s; /*动画持续时间*/
  -webkit-animation: fade-in 4s; /*针对webkit内核*/
}
#wrapper4 {
  animation: fade-in; /*动画名称*/
  animation-duration: 5s; /*动画持续时间*/
  -webkit-animation: fade-in 5s; /*针对webkit内核*/
}

/* 背景扩散 */
.feature {
  width: 100%;
  height: 50vh;
  display: flex;
  align-items: center;
  justify-content: center;
}
.feature-box {
  width: 200px;
  height: 200px;
  margin-top: -20%;
  position: relative;
  z-index: 2;
}
.pulse {
  width: 200px;
  height: 200px;
  line-height: 200px;
  background: #4892fb;
  border-radius: 50%;
}
/* .loading {
  width: 80%;
  margin: auto;
  text-align: center;
} */
.loadingone {
  width: 20%;
  margin: auto;
}
.loadingtwo {
  width: 30%;
  margin: auto;
}
.loadingthree {
  width: 40%;
  margin: auto;
}
.loadingfor {
  width: 50%;
  margin: auto;
}
.loadingfive {
  width: 60%;
  margin: auto;
}
.loadingsix {
  width: 70%;
  margin: auto;
}

.pulse1,
.pulse2 {
  position: absolute;
  width: 240px;
  height: 240px;
  left: 35%;
  top: -20px;
  margin-left: -90px;
  background: #4892fb;
  border-radius: 50%;
  opacity: 0;
  z-index: -1;
  box-shadow: 1px 1px 15px #3399ff;
}
.pulse1 {
  animation: warn1 1.5s linear;
  animation-iteration-count: infinite;
}
.pulse2 {
  animation: warn2 1.5s linear;
  animation-iteration-count: infinite;
}
@keyframes warn1 {
  0% {
    transform: scale(1);
    opacity: 0.01;
  }

  25% {
    transform: scale(1.2);
    opacity: 0.1;
  }

  50% {
    transform: scale(1.4);
    opacity: 0.07;
  }

  75% {
    transform: scale(1.6);
    opacity: 0.03;
  }

  100% {
    transform: scale(1.8);
    opacity: 0.01;
  }
}

@keyframes warn2 {
  0% {
    transform: scale(0.8);
    opacity: 0.01;
  }

  25% {
    transform: scale(0.8);
    opacity: 0.13;
  }

  50% {
    transform: scale(1);
    opacity: 0.1;
  }

  75% {
    transform: scale(1.2);
    opacity: 0.07;
  }

  100% {
    transform: scale(1.4);
    opacity: 0.01;
  }
}

/* 字体显影 */
.waitfor {
  width: 30%;
  height: 400px;
  margin: auto;
  position: relative;
  left: 40px;
  padding: 20px 0 0 0;
}

.waitTitle {
  width: 90%;
  margin-left: 7.5%;
  text-align: center;
  line-height: 30px;
  padding-bottom: 20px;
}

.waitTitle p {
  letter-spacing: 0.2em;
  transform: translate(0);
}

/* 结果
 */
.resultBox {
  width: 100%;
  text-align: center;
  padding: 30px 0 10px 0;
  line-height: 25px;
  /* border-bottom: 2px solid #8298cc; */
}
.resiltTitle {
  font-size: 20px;
  font-weight: 600;
  /* color: #0039bf; */
}
.resiltdetil {
  font-size: 12px;
  color: #c0c5ce;
  margin-top: 10px;
}
.trademarkBox {
  width: 90%;
  margin: 20px auto 0;
  border: 1px solid #efefef;
  text-align: center;
}
.trademarkcont {
  color: #52c5cb;
  padding: 20px 0 20px 0;
}
.setting-cont {
  width: 90%;
  margin: 20px auto 0;
}
.select-cont {
  background: #f5fcfc;
  width: 100%;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  border-bottom: 1px dashed #e7e9ef;
  color: #5a5a5a;
  padding: 20px 0 10px 0;
}
.select-item {
  width: 94%;
  padding: 0 3% 0 3%;
  line-height: 25px;
  display: flex;
  justify-content: space-between;
  color: #979797;
  font-size: 12px;
}
.itemName {
  font-size: 14px;
  color: #353a44;
}
.select >>> .el-collapse-item__header {
  font-size: 14px;
  /* background: #f5fcfc; */
  /* padding-left: 3%; */
  height: 40px;
  border-bottom: 1px dashed #e7e9ef;
}
.select-null >>> .el-collapse-item__content {
  padding-bottom: 0;
}
.changeactive >>> .el-tabs__header {
  margin: 0;
  background: #f5fcfc;
  padding: 10px 0 0 3%;
}
.Passrate {
  position: absolute;
  z-index: 100000;
  top: -10px;
  left: 50%;
}

.errorbox >>> .el-dialog__body {
  text-align: center;
}

.errorbox >>> .el-dialog__body {
  text-align: center;
}
</style>>
